import * as React from "react"

import id from "@irati/utils/id"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Container, StyledDot} from "./styled"

interface Props {
  text: string | React.ReactNode,
  color?: string,
  margin?: string,
  id?: string,
  center?: boolean,
  backgroundColor?: string,
  isWhiteText?: boolean,
  iconType?: keyof typeof IconTypes,
  className?: string
}

export default class Pill extends React.PureComponent<Props> {
  render() {
    const {text, color, margin, center, backgroundColor, isWhiteText, iconType, className} = this.props
    const idNamespace = id("pill", this.props)
    const icon = iconType ? IconTypes[iconType] : null

    return (
      <Container
        center={center}
        id={idNamespace}
        margin={margin}
        backgroundColor={backgroundColor}
        className={className}
        isWhiteText={isWhiteText}>
        {icon && <Icon icon={icon} marginRight={0.5} />}
        {text}
        {color && <StyledDot color={color} />}
      </Container>
    )
  }
}
